/* eslint-disable import/prefer-default-export */
import { ICmnHeadCell } from 'interface/cmn/commonInfo';
import {
  IAccountProjectListHeadCellProps,
  ICompAccountsHeadCellProps,
  IDiagnosticHeadCellProps,
  IDiagnosticHistoryHeadCellProps,
  IProjectListHeadCellProps,
  IProjectUsersListHeadCellProps,
} from 'interface/project/projectInfo';

export const projectListHeadCells: readonly ICmnHeadCell<IProjectListHeadCellProps>[] = [
  {
    id: 'projectState',
    align: 'center',
    disablePadding: false,
    label: '상태',
  },
  {
    id: 'projectType',
    align: 'center',
    disablePadding: false,
    label: '프로젝트 유형',
  },
  {
    id: 'name',
    align: 'center',
    disablePadding: false,
    label: '담당자',
  },
  {
    id: 'projectName',
    align: 'center',
    disablePadding: false,
    label: '프로젝트 이름',
  },
  {
    id: 'compName',
    align: 'center',
    disablePadding: false,
    label: '프로젝트 기업명',
  },
  {
    id: 'projectStartAt',
    align: 'center',
    disablePadding: false,
    label: '시작일',
  },
  {
    id: 'projectEndAt',
    align: 'center',
    disablePadding: false,
    label: '종료일',
  },
  {
    id: 'progress',
    align: 'center',
    disablePadding: false,
    label: '진행률',
  },
  {
    id: 'totalParticipantCount',
    align: 'center',
    disablePadding: false,
    label: '참여자',
  },
  {
    id: 'manage',
    align: 'center',
    disablePadding: false,
    label: '프로젝트 관리',
  },
];

export const compAccountsListHeadCells: readonly ICmnHeadCell<ICompAccountsHeadCellProps>[] = [
  {
    id: 'name',
    align: 'left',
    disablePadding: false,
    label: '이름',
  },
  {
    id: 'roleCode',
    align: 'center',
    disablePadding: false,
    label: '권한',
  },
  {
    id: 'compName',
    align: 'center',
    disablePadding: false,
    label: '소속',
  },
  {
    id: 'compRole',
    align: 'center',
    disablePadding: false,
    label: '직책/직급',
  },
  {
    id: 'id',
    align: 'center',
    disablePadding: false,
    label: '선택',
  },
];

export const projectUsersListHeadCells: readonly ICmnHeadCell<IProjectUsersListHeadCellProps>[] = [
  {
    id: 'userName',
    align: 'center',
    disablePadding: false,
    label: '이름',
  },
  {
    id: 'userCompName',
    align: 'center',
    disablePadding: false,
    label: '기업',
  },
  {
    id: 'userEmail',
    align: 'center',
    disablePadding: false,
    label: '이메일',
  },
  {
    id: 'add1',
    align: 'center',
    disablePadding: false,
    label: 'add1(ID)',
  },
  {
    id: 'partCode',
    align: 'center',
    disablePadding: false,
    label: '참여코드',
  },
  {
    id: 'isDone',
    align: 'center',
    disablePadding: false,
    label: '실시여부',
  },
  {
    id: 'result',
    align: 'center',
    disablePadding: false,
    label: '진단실행/결과',
  },
  {
    id: 'sendEmailAt',
    align: 'center',
    disablePadding: false,
    label: '메세지 발송시간',
  },
  {
    id: 'regAt',
    align: 'center',
    disablePadding: false,
    label: '등록시간',
  },
  {
    id: 'startAt',
    align: 'center',
    disablePadding: false,
    label: '진단시간',
  },
  {
    id: 'progressStep',
    align: 'center',
    disablePadding: false,
    label: '진행상황',
  },
  {
    id: 'doneAt',
    align: 'center',
    disablePadding: false,
    label: '완료시간',
  },
  {
    id: 'delete',
    align: 'center',
    disablePadding: false,
    label: '삭제',
  },
];
// 이메일, 이름, 휴대폰번호, 소속, 직급, 권한설정, 강사관리
export const accountManageListHeadCells: readonly ICmnHeadCell<ICompAccountsHeadCellProps>[] = [
  {
    id: 'email',
    align: 'center',
    disablePadding: false,
    label: '이메일',
  },
  {
    id: 'name',
    align: 'center',
    disablePadding: false,
    label: '이름',
  },
  {
    id: 'mobile',
    align: 'center',
    disablePadding: false,
    label: '휴대폰번호',
  },
  {
    id: 'compName',
    align: 'center',
    disablePadding: false,
    label: '소속',
  },
  {
    id: 'compRole',
    align: 'center',
    disablePadding: false,
    label: '직급',
  },
  {
    id: 'roles',
    align: 'center',
    disablePadding: false,
    label: '권한설정',
  },
  {
    id: 'etc',
    align: 'center',
    disablePadding: false,
    label: '강사관리',
  },
];
export const accountProjectListHeadCells: readonly ICmnHeadCell<IAccountProjectListHeadCellProps>[] = [
  {
    id: 'projectState',
    align: 'center',
    disablePadding: false,
    label: '상태',
  },
  {
    id: 'projectType',
    align: 'center',
    disablePadding: false,
    label: '프로젝트 유형',
  },
  {
    id: 'name',
    align: 'center',
    disablePadding: false,
    label: '담당자',
  },
  {
    id: 'compName',
    align: 'center',
    disablePadding: false,
    label: '프로젝트 기업명',
  },
  {
    id: 'projectStartAt',
    align: 'center',
    disablePadding: false,
    label: '시작일',
  },
  {
    id: 'projectEndAt',
    align: 'center',
    disablePadding: false,
    label: '종료일',
  },
  {
    id: 'progress',
    align: 'center',
    disablePadding: false,
    label: '진행률',
  },
  {
    id: 'manage',
    align: 'center',
    disablePadding: false,
    label: '프로젝트 관리',
  },
];

export const diagnosticHeadCells: readonly ICmnHeadCell<IDiagnosticHeadCellProps>[] = [
  {
    id: 'surveyName',
    align: 'center',
    disablePadding: false,
    label: '진단명',
  },
  {
    id: 'saveFileName',
    align: 'center',
    disablePadding: false,
    label: '진단 파일명',
  },
  {
    id: 'surveyType',
    align: 'center',
    disablePadding: false,
    label: '진단유형',
  },
  {
    id: 'updAt',
    align: 'center',
    disablePadding: false,
    label: '최종 업데이트 날짜',
  },
  {
    id: 'modify',
    align: 'center',
    disablePadding: false,
    label: '진단 수정',
  },
];

export const diagnosticHistoryHeadCells: readonly ICmnHeadCell<IDiagnosticHistoryHeadCellProps>[] = [
  {
    id: 'updAt',
    align: 'center',
    disablePadding: false,
    label: '날짜',
  },
  {
    id: 'saveFileName',
    align: 'center',
    disablePadding: false,
    label: '파일명',
  },
  {
    id: 'editHistory',
    align: 'center',
    disablePadding: false,
    label: '수정내역',
  },
];
